import { useTranslation } from 'react-i18next';

import { Award } from '../../../../../../../types/bonus';
import { USERNAME_KEY } from '../config';

export const useTemplatePreview = (award?: Award) => {
	const { t } = useTranslation('recognition');

	if (!award || !award.reason) {
		return '';
	}

	return award.reason.replace(USERNAME_KEY, t('awards.give_modal.recipient_tag'));
};
